/* eslint-disable no-undef, no-unused-vars */
import testDEVConfig from './test_dev.json';
import testINTConfig from './test_integration.json';
import prodConfig from './production.json';

const config = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return prodConfig;
    case 'testINT':
      return testINTConfig;
    case 'testDEV':
      return testDEVConfig;
    default:
      return testDEVConfig;
  }
};

export default config();
